/**
 * Implements Popup class.
 *
 * @package IPortalCore.
 */

const { __, _x, _n, _nx } = wp.i18n;

/**
 * Implements popups.
 */
class Popup {
	constructor( popup ) {
		this.popup = popup;
		this.id = popup.getAttribute( 'id' );
		this.shown = false;
		if ( ! this.id ) {
			return;
		}
		this.setup();
	};

	/**
	 * Modifies HTML and sets up event handlers.
	 */
	setup() {
		this.constructor.managed.push( this );

		var self = this;
		var $links = jQuery( 'a[href="#' + this.id + '"]' );
		$links.each(
			function() {
				var $link = jQuery( this );
				$link.on(
					'click',
					function( e ) {
						if ( ! self.shown ) {
							self.show();
						}
						e.preventDefault();
						e.stopPropagation();
					}
				);
			}
		);

		jQuery( document.body ).on(
			'show.bs.modal',
			this.onPopupShow.bind( this )
		);

		window.addEventListener(
			'hashchange',
			this.onHashChange.bind( this )
		);

		jQuery( this.popup ).wrapInner( '<div class="iportal-popup__inner"></div>' );

		// Check hash on load.
		this.onHashChange();
	};

	/**
	 * Shows the popup.
	 */
	show() {
		const $modal = jQuery( '<div></div>' );
		jQuery( this.popup ).children().first().appendTo( $modal );
		const $title = $modal.find( 'h1,h2,h3,h4,h5,h6' ).first();
		this.$modal = $modal;
		const title = $title.text();
		$title.remove();

		$modal.addClass( 'modal' )
			.attr( 'tabindex', '-1' )
			.attr( 'role', 'dialog' )
			.wrapInner( '<div class="modal-body entry-content"></div>' )
			.wrapInner( '<div class="modal-content"></div>' )
			.wrapInner( '<div class="modal-dialog modal-lg" role="document"></div>' );

		var copyButton = document.createElement( 'button' );
		copyButton.className = 'btn-secondary btn-primary btn-sm copy-url';
		copyButton.textContent = __( 'Copy pop-up URL', 'iportal-core' );
		copyButton.setAttribute( 'aria-label', copyButton.textContent );
		copyButton.addEventListener( 'click', this.onCopyURL.bind( this ) );

		$modal.find( '.modal-body' ).before(
			' <div class="modal-header">'
				+ '<h5 class="modal-title">' + title + '</h5> '
				+ '<div class="copy-url-wrap">'
				+ '<input disabled="disabled" type="text" class="copy-url-input">'
				+ '</div>'
				+ '<button type="button" class="close" data-dismiss="modal" aria-label="Close"> '
			+ '<span aria-hidden="true">&times;</span></button></div>'
		);
		this.copyURLInput = $modal.find( '.modal-header .copy-url-input' ).get( 0 );
		this.copyURLInput.before( copyButton );

		jQuery( document.body ).append( $modal );
		$modal.on( 'hidden.bs.modal', this.onPopupHide.bind( this ) );
		$modal.modal( 'show' );
	}

	/**
	 * Hides the popup.
	 */
	hide() {
		this.$modal.modal( 'hide' );
	}

	/**
	 * Handler for copy URL button clicks.
	 *
	 * Copies the popup's URL to the clipboard.
	 */
	onCopyURL() {
		var location = window.location;
		var href = location.protocol + '//'
				+ location.host
				+ location.pathname
				+ '#' + this.id;
		var input = this.copyURLInput;
		input.disabled = false;
		input.value = href;
		input.focus();
		input.select();
		var success = false;
		try {
			success = document.execCommand( 'copy' );
		} catch (err) {
		}
		if ( success ) {
			input.value = 'Copied to clipboard.';
		} else {
			input.value = "Could not copy URL.";
		}
		input.blur();
		input.disabled = true;
	};

	/**
	 * Handler for hash change events.
	 *
	 * Open the popup if it is referenced by the hash.
	 */
	onHashChange() {
		if ( window.location.hash === '#' + this.id ) {
			this.show();
		}
	};

	/**
	 * Handler for modal hide events.
	 *
	 * If the popup was hidden by a users request (and not by this class because
	 * another popup was shown), pops the latest hidden popup if any and shows it.
	 */
	onPopupHide( event ) {
		this.shown = false;

		// Remove the popup's id in the hash for cases where the popup has been
		// opened because of it.
		if ( window.location.hash === '#' + this.id ) {
			history.pushState(
				'',
				document.title,
				window.location.pathname + window.location.search
			);
		}

		if ( ! this.dontPop ) {
			var popup = this.constructor.stack.pop();
			if ( popup ) {
				popup.show();
			}
		}
		this.dontPop = false;

		this.$modal.find( '.iportal-popup__inner' ).appendTo( this.popup );
		this.$modal.modal( 'dispose' );
		this.$modal.remove();
		this.$modal = null;
	};

	/**
	 * Handler for global modal show events.
	 *
	 * If the event is fired for another instance and this instance is currently
	 * shown, hides this instance's popup and pushes it on the stack.
	 */
	onPopupShow( event ) {
		var self = this;
		if ( this.copyURLInput ) {
			this.copyURLInput.value = '';
		}
		var known = function( popup ) {
			return popup.id === self.id;
		};
		if ( ! this.constructor.managed.some( known ) ) {
			return;
		}

		if ( this.shown ) {
			this.dontPop = true;
			this.hide();
			this.constructor.stack.push( this );
		}
		if ( this.$modal && event.target == this.$modal.get( 0 ) ) {
			this.shown = true;
		}
	};

}
// Stack of hidden popups to be shown again later.
Popup.stack = [];
// All popups that are managed with this class.
Popup.managed = [];

export default Popup;
